<template>
  <div class="outer">
    <Calendar
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import Calendar from '../layout/Calendar.vue';

export default {
  name: 'Timetable',

  components: { Calendar },
};
</script>

<style scoped>
.outer {
  margin: 0;
  padding: 0;
  position: relative;
  max-height: 100vh;
}
</style>
